import * as R from 'ramda';
import {
  getItemsByProp,
  millisSecondTimeStampText,
  msToSecond,
  secondTimeStampDurationText,
  secondTimeStampText
} from '@/utils';
import {TASK_STATUS} from '@/config/enum';

const filter = [
  {label: '订单号', prop: 'publicOrderId'},
  {label: '患者姓名', prop: 'patientName'},
  {label: '患者ID', prop: 'examPatientId'},
  {label: '医生姓名', prop: 'doctorName'},
  {label: '医生姓名', prop: 'doctor'},
  {label: '医院', prop: 'hospitalName'},
  {label: '姓名', prop: 'agentName'},
  {label: '医院', prop: 'name'},
  {label: '医院缩写', prop: 'abbr'},
  {label: '代理商', prop: 'agentId'},
  {label: '代理商', prop: 'agent'},
  {label: '科室', prop: 'departmentName'},
  {label: '科室', prop: 'department'},
  {label: '缩写', prop: 'orderAbbr'},
  {label: '患者支付状态', prop: 'payStatus', dataType: 'number', options: [{label: '未支付', value: 0}, {label: '已支付', value: 1}, {label: '已退款', value: 2}]},
  {label: '代理商支付状态', prop: 'agentPayStatus', dataType: 'number', options: [{label: '未支付', value: 0}, {label: '已支付(余额)', value: 1}, {label: '已退款', value: 2}, {label: '已支付(代金)', value: 3}]},
  {label: '发票', prop: 'invoice', optionsName: 'invoiceOptions', dataType: 'number'},
  {label: '重建类型', prop: 'reconId', optionsName: 'itemNamesOptions', dataType: 'number'},
  {label: '病种', prop: 'diseaseId', optionsName: 'diseaseNamesOptions'},
  {label: '提交日期', type: 'datetimerange', start: 'submitTimeStart', end: 'submitTimeEnd', prop: '_submitTime'},
  {label: '患者支付日期', type: 'datetimerange', start: 'payTimeStart', end: 'payTimeEnd', prop: '_payTime'},
  {label: '医院', prop: 'hospital', optionsName: 'itemNamesOptions'},
  {label: '科室', prop: 'department', optionsName: 'itemNamesOptions'},
  {label: '省/市', prop: 'provinceCity', type: 'cascader', optionsName: 'itemNamesOptions'},
  {label: '创建日期', type: 'datetimerange', start: 'start', end: 'end', prop: '_createTime'},
];

const table = [
  {label: '订单号', prop: 'publicOrderId'},
  {label: '患者姓名', prop: 'patientName'},
  {label: '医院', prop: 'hospitalName'},
  {label: '最近登录时间', prop: 'loginTime'},
  {label: '现金余额', prop: 'moneySum', filter: ({moneySum}) => moneySum.toFixed(2)},
  {label: '代金余额', prop: 'vouchersSum', filter: ({vouchersSum}) => vouchersSum.toFixed(2)},
  {label: '协议价', prop: 'agentPrice', filter: ({agentPrice}) => agentPrice.toFixed(2)},
  {label: '新订单管控', prop: 'balancePolicy', filter: ({balancePolicy}) => (balancePolicy & 1) > 0 ? '须预存' : ''},
  {label: '患者支付方式', prop: 'paymentMode', filter: ({paymentMode}) => paymentMode > 0 ? '代理商收款码' : '精诊收款'},
  {label: '患者ID', prop: 'examPatientId'},
  {label: '代理商', prop: 'agentName'},
  {label: '科室', prop: 'name'},
  {label: '缩写', prop: 'orderAbbr'},
  {label: '邮箱', prop: 'email'},
  {label: '医院', prop: 'hospital_name'},
  {label: '医生姓名', prop: 'doctorName'},
  {label: '电话', prop: 'mobile'},
  {label: '省份', prop: 'provinceName'},
  {label: '城市', prop: 'cityName'},
  {label: '创建时间', prop: 'createdAt'},
  {label: '患者电话', prop: 'patientPhone'},
  {label: '医生姓名', prop: 'doctorName'},
  {label: '科室', prop: 'departmentName'},
  {label: '创建时间', prop: 'createTime'},
  {label: '创建时间', prop: 'createdAt'},
  {label: '提取码', prop: 'code'},
  {label: '提交时间', prop: 'submitTime', filter: ({submitTime}) => secondTimeStampText(submitTime)},
  {label: '修改时间', prop: 'updatedAt', filter: ({updatedAt}) => millisSecondTimeStampText(updatedAt)},
  {label: '完成时间', prop: 'processFinishTime', filter: ({processFinishTime}) => secondTimeStampText(processFinishTime)},
  {
    label: '目前用时',
    prop: '_nowTime',
    filter: ({processFinishTime, processStartTime}) => {
      if (processFinishTime && processStartTime) {
        return secondTimeStampDurationText({startTime: processStartTime, endTime: processFinishTime});
      } else if (!processFinishTime && processStartTime) {
        return secondTimeStampDurationText({startTime: processStartTime, endTime: msToSecond(Date.now())});
      }
    },
  },
  {
    label: '订单状态',
    prop: 'status',
    filter: ({status}) => {
      switch (status) {
        case TASK_STATUS.UNSUBMIT:
          return '待提交';
        case TASK_STATUS.SUBMITED:
          return '已提交';
        case TASK_STATUS.PROCESSING:
          return '处理中';
        case TASK_STATUS.FINISHED:
          return '已完成';
        default:
          return '';
      }
    },
  },
  {
    label: '患者支付状态',
    prop: 'payStatus',
    filter: ({payStatus, agentPayStatus}, seg) => {
      if (seg == null || seg === 1) {
        switch (payStatus) {
          case 0:
            return '患者未支付';
          case 1:
            return '患者支付';
          case 2:
            return '患者退款';
        }
      } else {
        switch (agentPayStatus) {
          case 0:
            return '代理未支付';
          case 1:
            return '代理余额支付';
          case 2:
            return '代理退款';
          case 3:
            return '代理代金支付';
          case 4:
            return '代理申请退款';
        }
      }
      return '';
    },
  },
  {label: '患者支付时间', prop: 'payTime', filter: ({payTime}) => secondTimeStampText(payTime)},
  {label: '重建组', prop: 'processGroup'},
  {label: '重建负责人', prop: 'processor'},
  {
    label: '发票',
    prop: 'invoice',
    filter: ({invoice}) => {
      return invoice === 1 ? '是' : '否';
    }
  },
  {
    label: '重建类型',
    prop: 'reconIdNames',
    filter: ({reconNames}) => {
      if (R.is(Array, reconNames)) {
        return R.join(',', reconNames);
      }
      return '';
    }
  },
];

// 全部
export const orderAllFilter = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName',  '_submitTime'], filter);
// 一般用户的订单列表页面
export const orderAllTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName',  'submitTime', '_nowTime', 'updatedAt', 'status'], table);
/* , 'itemNames' */
// 管理员用户的订单列表页面
export const orderAllFilterInner = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName',  'hospitalName', 'departmentName', 'reconId', '_submitTime'], filter);
export const orderAllTableInner = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName',  'hospitalName', 'departmentName', 'submitTime', '_nowTime', 'status','reconIdNames'], table);

// 已完成
export const orderFinishedFilter = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', '_submitTime'], filter);
export const orderFinishedTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'departmentName', 'submitTime', '_nowTime', 'processFinishTime', 'code'], table);
export const orderFinishedInnerFilter = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName', 'reconId', 'diseaseId', '_submitTime'], filter);
/* , 'itemNames' */
export const orderFinishedInnerTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName', 'submitTime', '_nowTime', 'reconIdNames'], table);

// 待提交
export const orderUnsubmitFilter = getItemsByProp(['patientName', 'examPatientId', 'doctorName'], filter);
export const orderUnsubmitTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'departmentName', '_nowTime', 'submitTime', 'reconIdNames'], table);
export const orderUnsubmitInnerFilter = getItemsByProp(['patientName', 'hospitalName', 'departmentName', 'reconId', '_submitTime'], filter);
/* 'itemNames', */
export const orderUnsubmitInnerTable = getItemsByProp(['patientName', 'hospitalName', 'departmentName', 'patientPhone', '_nowTime','reconIdNames'], table);

// 已提交
export const orderSubmitedFilter = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', '_submitTime'], filter);
export const orderSubmitedTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'departmentName', '_nowTime', 'submitTime', 'reconIdNames'], table);
export const orderSubmitedInnerFilter = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName', 'reconId', '_submitTime'], filter);
/* , 'itemNames' */
export const orderSubmitedInnerTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName', 'submitTime', '_nowTime', 'reconIdNames'], table);

// 处理中
export const orderProcessingFilter = orderSubmitedFilter;
export const orderProcessingTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'departmentName', '_nowTime', 'submitTime', 'reconIdNames'], table);
export const orderProcessingInnerFilter = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName', 'reconId',  '_submitTime'], filter);
/* , 'itemNames' */
export const orderProcessingInnerTable = getItemsByProp(['publicOrderId', 'patientName', 'examPatientId', 'doctorName', 'hospitalName', 'departmentName', 'submitTime', '_nowTime', 'reconIdNames'], table);

// 科室管理
export const departmentAllFilter = getItemsByProp(['hospital', 'department', 'orderAbbr', 'doctor', 'agent', '_createTime'], filter);
export const departmentAllTable = getItemsByProp(['hospitalName', 'name', 'orderAbbr', 'doctorName', 'mobile', 'agentName', 'createdAt'], table);
// 代理商管理
export const agentAllFilter = [{
  label: '名称',
  prop: 'name'
}, {
  label: '创建日期', type: 'datetimerange', start: 'start', end: 'end', prop: '_createTime'
}];
//export const agentAllTable = getItemsByProp(['agentName', 'mobile', 'email', 'createdAt', 'loginTime', 'moneySum', 'vouchersSum', 'agentPrice', 'balancePolicy', 'paymentMode'], table);
export const agentAllTable = getItemsByProp(['agentName', 'mobile', 'email', 'createdAt', 'loginTime'], table);

// 医院管理
export const hospitalAllFilter = getItemsByProp(['name', 'abbr', 'provinceCity', '_createTime'], filter);
export const hospitalAllTable = [{
  label: '医院',
  prop: 'name'
}, {
  label: '医院缩写',
  prop: 'abbr'
}, {
  label: '省份',
  prop: 'provinceName'
}, {
  label: '城市',
  prop: 'cityName'
}, {
  label: '创建时间',
  prop: 'createdAt'
}, {
  label: 'logo',
  prop: 'logo'
}];

// 日志审计
export const logAuditAllFilter = [
  {
    label: '危险等级',
    prop: 'logLevel',
    dataType: 'number',
    options: [{label: '全部', value: ''}, {label: '--', value: 1}, {label: '排除', value: 2}, {
      label: '低',
      value: 3
    }, {label: '高', value: 4}]
  },
  {label: '姓名', prop: 'name'},
  {label: '登陆日期', type: 'datetimerange', start: 'start', end: 'end', prop: '_createTime'},
];
export const ipAllFilter = [
  {
    label: '危险等级',
    prop: 'logLevel',
    dataType: 'number',
    options: [{label: '全部', value: ''}, {label: '--', value: 1}, {label: '排除', value: 2}, {
      label: '低',
      value: 3
    }, {label: '高', value: 4}]
  },
  {label: '电话', prop: 'name'},
  {label: '登陆日期', type: 'datetimerange', start: 'start', end: 'end', prop: '_createTime'},
];
export const logAuditAllTable = [
  {label: '危险等级', prop: 'logLevel'},
  {label: '电话（账号）', prop: 'username'},
  // { label: '下载量', prop: 'name' },
  {label: '姓名', prop: 'name'},
  {label: 'IP地址', prop: 'ip'},
  {label: '登陆时间', prop: 'createdAt'},
  {label: '备注', prop: 'remark'}
];
export const ipAllTable = [
  {label: '危险等级', prop: 'logLevel'},
  {label: '电话（账号）', prop: 'username'},
  // { label: '下载量', prop: 'name' },
  {label: '姓名', prop: 'username'},
  {label: '上次IP地址', prop: 'lastIp'},
  {label: '本次IP地址', prop: 'ip'},
  {label: '登陆时间', prop: 'createdAt'},
  {label: '备注', prop: 'remark'}
];

export const stlConfigAllFilter = [
  {
    label: '模型名',
    prop: 'name',
  },
];

export const stlConfigAllTable = [
  {
    label: '分组',
    prop: 'group',
  },
  {label: '模型名', prop: 'name'},
  {label: '是否显示', prop: 'show', filter: ({show}) => show === 0 ? '否' : '是'},
  {
    label: '不透明度',
    prop: 'opacity',
    filter: ({opacity}) => {
      if (!opacity && opacity !== 0) {
        return '';
      }
      console.log(opacity);
      return Number(opacity) === 0 ? '透明' : (Number(opacity) === 100 ? '不透明' : (Number(opacity) + '%'));
    }
  },
  {
    label: '颜色',
    prop: 'color',
    filter: ({color, opacity}) => {
      // ;opacity: ${opacity / 100}
      if (color) {
        return `<div style="width: 20px;height: 20px;background-color: rgb(${color})"></div>`;
      }
      return '--';
    }
  },
  {label: '顺序', prop: 'sort'},
  {
    label: '标签',
    prop: 'tag',
    filter: ({tag}) => {
      if (tag === 0) {
        return '轮廓';
      } else if (tag === 1) {
        return '血管';
      } else if (tag === 2) {
        return '病灶';
      } else if (tag === 3) {
        return '切缘';
      }
      return '--';
    }
  },
];

export const refundAllFilter = [
  {
    label: '退款单号',
    prop: 'refundNo',
  },
  {
    label: '患者姓名',
    prop: 'patientName',
  },
  {
    label: '医院名称',
    prop: 'hospitalName',
  },
  {
    label: '科室名称',
    prop: 'departmentName',
  },
  {
    label: '医生姓名',
    prop: 'doctorName',
  },
  {
    label: '操作人',
    prop: 'optName',
  },
];

export const refundAllTable = [
  // {label: '订单号', prop: 'outOrderId'},
  {label: '退款单号', prop: 'refundNo'},
  {label: '患者id', prop: 'examPatientId'},
  {label: '患者姓名', prop: 'patientName'},
  {label: '医院名称', prop: 'hospitalName'},
  {label: '科室名称', prop: 'departmentName'},
  {label: '医生姓名', prop: 'doctorName'},
  {label: '退款金额', prop: 'refundAmt'},
  {label: '退款原因', prop: 'remark'},
  {label: '操作人', prop: 'optName'},
  {label: '退款状态', prop: 'status', filter: ({status}) => status === 0 ? '退款中' : (status === 1 ? '退款成功' : '退款失败')},
  {label: '退款信息', prop: 'errMsg'},
  {label: '退款时间', prop: 'refundTime'}
];



// WEBPACK FOOTER //
// ./src/router/config.js